var _image;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoFilter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "ico_filter",
    "data-name": "ico filter",
    width: 19,
    height: 17,
    xlinkHref: "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAARCAYAAAA/mJfHAAABC0lEQVQ4jb3Uvy4EURTH8c+gEPEn4inQK2kVClEQKkoND6CmkYhIrA3iAUSl2EKjUpF4DZWgFBy5yd2YbNidsHGS2/zmzrnf3/ndGRHRXFMR0YiIy4iYKOmVVxERuxjDmq96xxkCPdpXev6Mk9QsOmyuWjt9WMIoNjGeX7xDHUVFsic0ihJYEtezxfpv0Iruuexs4aeaxi3uMVcmO8AwPio0SSNIc15t0Ws47HqaixipSPaR6VYwm7Ub7OHqLwHMZ8sXTeHf0pzBOY4xVKVZIqu1pPmGfiyX9j2kG55tpa+iFegFR91MczudtJDTbDZ9xSD2MZC1a5yi95vRJNL012ib5iQ28IitjlcHn9cEiXRl30rnAAAAAElFTkSuQmCC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoFilter);
export default __webpack_public_path__ + "static/media/ico_filter.623570bb.svg";
export { ForwardRef as ReactComponent };